<!--
 * @Author: fengzhongmei
 * @Date: 2020-05-20 16:18:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-04 16:18:04
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="info-content-table"
         v-if="show">
        <div v-for="(item,key) in confirmData"
             :key="key">
            <h4 style="padding-bottom:0px;padding: 10px 0 5px 0px;">{{item.name || '--'}}</h4>
            <div class="module">
                <div class="change-module"
                     style="border:none;">
                    <div class="left">
                        <h4>{{$t('配置')}}</h4>
                    </div>
                    <div class="right">
                        <Row v-if="item.config">
                            <Col span="8"
                                 v-for="(subItem,index) in item.config"
                                 :key="index"
                                 v-if="subItem.value&&subItem.value.length>0">
                            <div class="show-item"
                                 :title="$t(subItem.label)+'：'+subItem.value">
                                <span class="title">{{$t(subItem.label)}}：</span>
                                <span class="value">
                                    {{(subItem.value===null||subItem.value==='')?'--':subItem.value}}
                                </span>
                            </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="change-module">
                    <div class="left">
                        <h4>{{$t('变更前')}}</h4>
                    </div>
                    <div class="right">
                        <Row v-if="item.config">
                            <Col span="8"
                                 v-for="(subItem,index) in item.before"
                                 :key="index"
                                 v-if="subItem.value&&subItem.value.length>0">
                            <div class="show-item"
                                 :title="$t(subItem.label)+'：'+subItem.value">
                                <span class="title">{{$t(subItem.label)}}：</span>
                                <span class="value">
                                    {{(subItem.value===null||subItem.value==='')?'--':subItem.value}}
                                </span>
                            </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="change-module">
                    <div class="left">
                        <h4>{{$t('变更后')}}</h4>
                    </div>
                    <div class="right">
                        <Row v-if="item.config">
                            <Col span="8"
                                 v-for="(subItem,index) in item.after"
                                 :key="index"
                                 v-if="subItem.value&&subItem.value.length>0">
                            <div class="show-item"
                                 :title="$t(subItem.label)+'：'+subItem.value">
                                <span class="title">{{$t(subItem.label)}}：</span>
                                <span class="value">
                                    {{(subItem.value===null||subItem.value==='')?'--':subItem.value}}
                                </span>
                            </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Row class="expand-table-header">
            <i-col span="3">
                <p>{{$t('产品')}}</p>
            </i-col>
            <i-col span="9">
                <p>{{$t('配置')}}</p>
            </i-col>
            <i-col span="6">
                <p>{{$t('变更前')}}</p>
            </i-col>
            <i-col span="6">
                <p>{{$t('变更后')}}</p>
            </i-col>
        </Row>
        <Row class="expand-table-content"
             v-for="(item,key) in confirmData"
             :key="key">
            <i-col span="3">
                <p class="rc-ellipsis"
                   :title="item.name">{{item.name || '--'}}</p>
            </i-col>
            <i-col span="9">
                <div v-if="item.config">
                    <p class="rc-ellipsis"
                       v-for="(subItem,index) in item.config"
                       v-if="subItem.value&&subItem.value.length>0"
                       :key="index"
                       :title="subItem.label+'：'+subItem.value">{{subItem.label+'：'+(subItem.value===null?'--':subItem.value)}}</p>
                </div>
            </i-col>
            <i-col span="6">
                <div v-if="item.before">
                    <p class="rc-ellipsis"
                       v-for="(subItem,index) in item.before"
                       :key="index"
                       v-if="subItem.value"
                       :title="subItem.label+'：'+subItem.value">{{subItem.label+'：'+(subItem.value===null?'--':subItem.value)}}</p>
                </div>
            </i-col>
            <i-col span="6">
                <div v-if="item.after">
                    <p class="rc-ellipsis"
                       v-for="(subItem,index) in item.after"
                       :key="index"
                       v-if="subItem.value"
                       :title="subItem.label+'：'+subItem.value">{{subItem.label+'：'+(subItem.value===null?'--':subItem.value)}}</p>
                </div>
            </i-col>
        </Row> -->
    </div>
</template>

<script>
export default {
    name: 'confirmation',
    props: ['configData'],
    data () {
        return {
            show: false,
            confirmData: [{
                name: '',
                config: [],
                before: [],
                after: []
            }]
        }
    },
    methods: {
        open () {
            this.show = true
            this.confirmData = []
            this.confirmData.push(this.configData)
        }
    }
}
</script>
<style lang="less" scoped>
.info-content-table {
    font-size: 12px;
    margin: 10px 0 10px 0;
    background: #fff;
    line-height: 25px;
    padding: 0px 15px 15px 15px;
    h4 {
        padding: 9px 0 0px 36px;
        font-size: 12px;
    }
    p {
        padding: 0 15px;
    }
    .expand-table-header {
        padding: 5px 15px;
        background: #e9e9e9;
        font-weight: 600;
        margin-top: -1px;
    }
    .expand-table-content {
        padding: 15px 15px;
    }
    .module {
        border: 1px solid #eee;
        .change-module {
            background: #fff;
            padding-top: 5px;
            min-height: 40px;
            border-top: 1px dotted #eee;
            .left {
                display: inline-block;
                width: 135px;
                float: left;
            }
            .right {
                display: inline-block;
                width: calc(~'100% - 135px');
                .show-item {
                    margin-bottom: 5px;
                    font-size: 12px;
                    .title {
                        display: inline-block;
                        width: 120px;
                        color: #999;
                        text-align: right;
                    }
                    .value {
                        display: inline-block;
                        width: calc(~'100% - 120px');
                        position: relative;
                        top: 9px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
        }
    }
}
</style>
